// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"a43fe53e","232":"b44f8914","578":"7e3c5065","804":"39e423fa","837":"e869acd2","882":"ee891fd5"}[chunkId] + ".chunk.js";
};